import { ActivityListProps } from "./activity-list-types";
import { ActivityListContainer, EmptyActivityList, ListWrapper } from "./style-component";
import ActivityCard from "../activity-card/activity-card";
import SectionWithHeadings from "../section-with-headings/section-with-headings";

const ActivityList: React.FC<ActivityListProps> = ({ activities }) => {
	return (
		<ActivityListContainer>
			<SectionWithHeadings title="Actividad" titleColor="default">
				<ListWrapper>
					{activities.length === 0 ? (
						<EmptyActivityList>No hay transacciones aún</EmptyActivityList>
					) : (
						activities.map((activity, index) => (
							<ActivityCard
								key={index}
								title={activity.title}
								date={activity.date}
								image={activity.image}
								balance={activity.balance}
							/>
						))
					)}
				</ListWrapper>
			</SectionWithHeadings>
		</ActivityListContainer>
	);
};

export default ActivityList;